import React from 'react';
import styled from '@emotion/styled';
import 'external-svg-loader';

import { SecondaryButton } from '../shared/Buttons';

import { Config, AccessibilityText } from '@vm/omega-shared-component-webapp';

const Icon = styled.svg({
  height: '100%',
});

type Props = {
  text: string;
  cta: string;
};

export const IconButton: React.FC<Props> = ({ text, cta }) => {
  const srMessage = `opens a new tab`;
  const concatTitle = text.replace(/ /g, '_');
  const srID = `sr-${concatTitle}`;

  return (
    <SecondaryButton
      aria-describedby={srID}
      data-testid='mp-product-link-button'
      title={text}
      className='icon'
      onClick={() => {
        window.open(cta);
      }}
    >
      <Icon data-src={`${Config.get('image_cdn_base_url')}/ui/shared-component-webapp/shared/open.svg`} />
      <AccessibilityText message={srMessage} srID={srID} />
      {text}
    </SecondaryButton>
  );
};
